import { render, staticRenderFns } from "./ThgBillingSelectionItemUserAddressData.vue?vue&type=template&id=7b323e4b&"
import script from "./ThgBillingSelectionItemUserAddressData.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingSelectionItemUserAddressData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VIcon,VSkeletonLoader,VTextField})
